<template>
  <div class="subscription-lesson-plan">
    <page-title class="subscription-lesson-plan__title">
      Unlock <span>all ReadTheory Premium Features</span><br />+ the Fall Lesson Bundle.
    </page-title>
    <div class="subscription-lesson-plan__content">
      <rt-picture
        class="subscription-lesson-plan__content-picture"
        src="/assets/app/class/lesson-bundle-bg.png"
        :autosize="false"
      />
      <div class="subscription-lesson-plan__content-features">
        <p class="subscription-lesson-plan__content-features-summary">
          This will allow you to assign specific passages including some for Fall that you can pair with the following:
        </p>
        <ul class="subscription-lesson-plan__content-list">
          <li
            class="subscription-lesson-plan__content-item"
            v-for="feature of lessonFeatures"
          >
            <rt-picture
              src="/assets/app/class/icon-item-checkmark.svg"
              :autosize="false"
            />
            <p class="subscription-lesson-plan__content-item-text">
              {{ feature }}
            </p>
          </li>
        </ul>
        <primary-button
          class="btn-choose-plan"
          @click="handleChooseMyPlan"
        >
          Choose My Plan
        </primary-button>
      </div>
    </div>
    <subscription-satisfaction class="subscription-lesson-plan__satisfaction" />
  </div>
</template>

<script>
import PageTitle from "../../common/PageTitle.vue";
import RtPicture from "../../common/Picture.vue";
import PrimaryButton from "../../common/PrimaryButton.vue";
import SubscriptionSatisfaction from "./SubscriptionSatisfaction.vue";
import RTNewGA4Analytics from "common/RTNewGA4Analytics";

const SUBSCRIPTION_LESSON_FEATURES = [
  "No-Prep Printable Worksheets ",
  "Writing Prompts ",
  "Passage Aligned Discussion Starters",
  "Passage Aligned Debate Prompts",
  "Competition Trackers",
  "Bulletin Board Cutouts",
  "Reward Certificates",
];

export default {
  props: {
    pricingName: {
      type: String,
      default: "",
    },
  },
  components: {
    PageTitle,
    RtPicture,
    PrimaryButton,
    SubscriptionSatisfaction,
  },
  data() {
    return {
      lessonFeatures: SUBSCRIPTION_LESSON_FEATURES,
    };
  },
  methods: {
    handleChooseMyPlan() {
      RTNewGA4Analytics.sendEvent("clicked_fall_plan", {
        name: this.pricingName,
      });
      this.$emit("onShowPlan");
    },
  },
};
</script>

<style lang="scss" scoped>

@import "../../common/variables";

.subscription-lesson-plan {
  background: $green-200;
  padding: 64px;
  border-radius: 22px;
  &__title {
    margin: 0;
    text-align: center;
    font-size: 36px;
    color: $black;
    span {
      color: $green-100;
    }
  }

  &__content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 64px;
    text-align: left;
    &-picture {
      margin-right: 40px;
    }

    &-features {
      flex: 1;
      max-width: 501px;
      * {
        color: $title-grey;
      }

      &-summary {
        text-align: left;
      }
    }

    &-list {
      list-style: none;
    }

    &-item {
      display: flex;
      align-items: center;
      margin-top: 14px;
      &-text {
        margin-left: 12px;
        font-size: 14px;
      }
    }

    .btn-choose-plan {
      padding: 16px 32px;
      margin: 40px 0 0;
      border: 0;
      color: $default-white;
    }
  }

  &__satisfaction {
    background: transparent;
    margin: 64px auto 0;
  }

  @media(max-width: 960px) {
    &__content {
      display: block;
      &-picture {
        display: block;
        margin: 0 auto;
      }

      &-features {
        margin-top: 20px;
      }
    }
  }

  @media(max-width: 767px) {
    padding-left: 24px;
    padding-right: 24px;
  }
}
</style>
